import { BCMSRecord, DisabledPrompt, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import LayoutContainer, { LeftColumnContainer, RightColumnContainer } from 'components/shared/containers/LayoutContainer';
import MainContentContainer from 'components/shared/containers/MainContentContainer';
import { UIPrimaryButton, UISecondaryButton } from 'components/ui/UIButton';
import { Card } from "model";
import "./styles.css";

export default function CreditCardSummaryWidget(props) {
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);
  BCMSRecord.globalControllerFor([ Card  ], globalController);
  const navigate = useRoute();

  return (
    <MainContentContainer className="credit-card-summary-widget">
      <LayoutContainer>
        <LeftColumnContainer>
          <div className="flex-container flex-vertical text-center">
            <div className="flex-height detail-group">
              <span className="label-text" data-point="credit_details_current_balance">Current Balance</span>
              <h3 className="amount-text">{card.balance.format()}</h3>
            </div>
            <div className="flex-height detail-group">
              <span className="label-text"  data-point="credit_details_available_balance">Available Balance</span>
              <h3 className="amount-text">{card.balance.format()}</h3>
            </div>
            <div className="flex-height detail-group">
              <span className="label-text"  data-point="credit_details_credit_limit">Credit Limit</span>
              <h3 className="amount-text">{card.limit.format()}</h3>
            </div>
            <div className="flex-height">
              <DisabledPrompt>
                <UIPrimaryButton className={ !card.active ? "disabled" : "" } text="View More"  dataPoint="credit_details_view_more"/>
              </DisabledPrompt>
            </div>
          </div>
        </LeftColumnContainer>
        <RightColumnContainer>
         <div className="flex-container flex-vertical text-center">
            <div className="flex-height detail-group">
              <span className="label-text"  data-point="credit_details_min_payment">Minimum Payment Amount</span>
              <h3 className="amount-text">{card.minPaymentAmount.format()}</h3>
            </div>
            <div className="flex-height detail-group">
              <span className="label-text"  data-point="credit_details_payment_due">Payment Due Date</span>
              <h3 className="amount-text">{card.dateDue.format("M d, Y")}</h3>
            </div>
            <div className="flex-height detail-group">
              <span className="label-text"  data-point="credit_details_auto_payment">Auto Payment</span>
              <h3 className="amount-text">ON</h3>
            </div>
            <div className="flex-height">
              <UISecondaryButton className={ !card.active ? "disabled" : "" } text="Make a Payment"  dataPoint="credit_details_make_payment" onClick={() => {navigate("/home/payments/"+cardID)}}/>
            </div>
          </div>
          
        </RightColumnContainer>
      </LayoutContainer>
    </MainContentContainer>
  );
}